import { AlphaXIcon } from './AlphaXIcon';

/**
 * author: GreenTurtwig
 * id 44344AAE-07D8-455B-AA2E-68474E8829FE
 * name alpha-x
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-x.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetXIcon = AlphaXIcon;
export default AlphabetXIcon